import { Link } from "react-router-dom"
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import '../styles/Login.css'
import { useState } from "react"
import { callSupportLoginPost } from "../actions/login"

let Login = ({ callSupportLoginPost }) => {
    const [email, setEmail] = useState('')

    const submit = (e) => {
        e.preventDefault()
        callSupportLoginPost(email, _ => window.navigate('/support/code'))
    }

    return (
        <>
            <div className="container-login d-flex align-items-stretch">
                <div className="sdk d-flex flex-column align-items-center">
                    <Link to={'/support/login'} className="logo"><img src="/assets/img/logo.png" alt="Espartaco Soluções" /></Link>
                    <div className="authfast-sdk">
                        <div className="box" style={{ width: '100%' }}>
                            <div className="login" style={{ flex: '1 1 0%', maxWidth: '340px' }}>
                                <div className="sign-up">
                                    <h1 className="text-center m-0 title-h1">Já sou cadastrado</h1> <span className="separator title-sep"></span>
                                    <form onSubmit={submit}>
                                        <div className="form-row">
                                            <div className="col-12 form-group input-group">
                                                <input type="text" placeholder="Digite seu e-mail" className="form-control bg-input" style={{ width: 'auto !important' }} onChange={(e) => setEmail(e.target.value)} value={email} />
                                            </div>
                                            <div className="col-md-12 d-flex align-items-start justify-content-between">
                                                <button type="submit" className="btn-access">Validar</button>
                                                <Link to={'/account/login'} className="mt-1"><small>Voltar para o login</small></Link>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="img d-flex align-items-center shadow-video">
                    <video autoPlay loop className="bg-video">
                        <source src="/assets/video/background.mp4" type="video/mp4" />
                    </video>
                </div>
            </div>
        </>
    )
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            callSupportLoginPost,
        },
        dispatch
    );


export default connect(mapStateToProps, mapDispatchToProps)(Login)
